import { Moon, Sun } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useTheme } from "@/hooks/useTheme";

export function ThemeToggle() {
  const { theme, toggleTheme, mounted } = useTheme();
  const isDark = theme === "dark";

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={toggleTheme}
      aria-label={isDark ? "ライトモードに切り替え" : "ダークモードに切り替え"}
      aria-pressed={isDark}
      title={isDark ? "ライトモードに切り替え" : "ダークモードに切り替え"}
      className="rounded-full border-border/60 bg-background/60 backdrop-blur-md transition-colors hover:bg-accent/10"
    >
      {mounted ? (
        isDark ? (
          <Sun className="h-[1.15rem] w-[1.15rem]" aria-hidden="true" />
        ) : (
          <Moon className="h-[1.15rem] w-[1.15rem]" aria-hidden="true" />
        )
      ) : (
        <Sun className="h-[1.15rem] w-[1.15rem] opacity-0" aria-hidden="true" />
      )}
    </Button>
  );
}
